export default __webpack_public_path__ + "static/media/alert_icon.5d5a3ca0.svg";